import React from "react";
import DSOButton from "./UI/button/DSOButton";
import "./confirm-exit.modal.scss";
import CustomModal from "./UI/modal/CustomModal";
import { persistor } from "../store/store";

const ConfirmExitModal = ({ isModalOpen, setIsModalOpen }) => {
  /**
   * @description This function is used to logout the user and clear the local storage
   */
  const onClickYes = () => {
    persistor.purge();
    window.location.href = "/";
  };

  return (
    <CustomModal open={isModalOpen} setOpen={setIsModalOpen} closable={true}>
      <div className="logout-modal">
        <div className="logout-titles">
          <div className="logout-title">Are you sure you want to logout?</div>
          <div className="logout-subtitle animate__animated animate__fadeInUp">
            You will have to enter your username and password to <br />
            login again
          </div>
        </div>

        <div className="logout-btn">
          <DSOButton
            className="full-width"
            text="Logout anyway"
            btnType="next"
            onClick={() => {
              onClickYes();
              setIsModalOpen(false);
            }}
          />
        </div>
      </div>
    </CustomModal>
  );
};
export default ConfirmExitModal;
